module.exports = __webpack_public_path__ + "images/404.1790731042052.png";